import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "style", "tips"],
        },
        controller: {
            label: "控制属性",
            keys: ["align", "expand"],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        style: Object.assign({}, baseAttribute.style),
        align: {
            inputMethod: ControlAttributeType.Dropdown,
            value: "left",
            options: {
                list: [
                    {
                        value: "left",
                        label: i18n.t('dataitem.Left').toString(),
                    },
                    {
                        value: "center",
                        label: i18n.t('dataitem.Middle').toString(),
                    },
                    {
                        value: "right",
                        label: i18n.t('dataitem.Right').toString(),
                    },
                ],
            },
        },
    },
};
